import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
function createStyledContext(props) {
  const OGContext = createContext(null);
  const OGProvider = OGContext.Provider;
  const Context = OGContext;
  const Provider = ({
    children,
    ...values
  }) => {
    return /* @__PURE__ */ jsx(OGProvider, { value: useMemo(() => values, [JSON.stringify(values)]), children });
  };
  Context.Provider = Provider;
  Context.props = props;
  return Context;
}
export {
  createStyledContext
};
//# sourceMappingURL=createStyledContext.js.map
